export const PERIODOS_DISPONIBLES = [
  { label: "Diario", value: "DAYLY", maxIntervalSync: 365, maxConsulta: 365 },
  { label: "Semanal", value: "WEEKLY", maxIntervalSync: 52, maxConsulta: 52 },
  { label: "Mensual", value: "MONTHLY", maxIntervalSync: 12, maxConsulta: 12 },
  { label: "Anual", value: "ANNUAL", maxIntervalSync: 1, maxConsulta: 5 },
];
